import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { getSvgStyles } from 'baseui/icon';
import { styled } from '../../../theme/utils.js';
import { Icon } from '../icon.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Svg = forwardRef((_a, ref) => {
  var _b = _a, { title, titleId } = _b, props = __objRest(_b, ["title", "titleId"]);
  return jsxs("svg", __spreadProps(__spreadValues({}, props), { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", ref, "aria-labelledby": titleId, children: [title ? jsx("title", { id: titleId, children: title }) : null, jsx("path", { fill: "currentColor", d: "M7.98778 10C10.0208 10 11.6758 8.346 11.6758 6.313C11.6758 4.28 10.0218 2.625 7.98778 2.625C5.95378 2.625 4.30078 4.279 4.30078 6.313C4.30078 8.347 5.95478 10 7.98778 10ZM7.98778 4.625C8.91878 4.625 9.67578 5.382 9.67578 6.313C9.67578 7.244 8.91878 8 7.98778 8C7.05678 8 6.30078 7.243 6.30078 6.313C6.30078 5.383 7.05778 4.625 7.98778 4.625Z" }), jsx("path", { fill: "currentColor", d: "M15.9878 14.041C18.0208 14.041 19.6758 12.387 19.6758 10.354C19.6758 8.32102 18.0218 6.66602 15.9878 6.66602C13.9538 6.66602 12.3008 8.32002 12.3008 10.354C12.3008 12.388 13.9548 14.041 15.9878 14.041ZM15.9878 8.66602C16.9188 8.66602 17.6758 9.42302 17.6758 10.354C17.6758 11.285 16.9188 12.041 15.9878 12.041C15.0568 12.041 14.3008 11.284 14.3008 10.354C14.3008 9.42402 15.0578 8.66602 15.9878 8.66602Z" }), jsx("path", { fill: "currentColor", d: "M17.9905 15H13.0005C13.0005 12.794 11.2065 11 9.00047 11H6.98047C4.77447 11 2.98047 12.794 2.98047 15V22H20.9905V18C20.9905 16.346 19.6445 15 17.9905 15ZM10.9705 15V20H4.98047V15C4.98047 13.897 5.87747 13 6.98047 13H9.00047C10.1035 13 11.0005 13.897 11.0005 15H10.9705ZM18.9905 20H13.0005V17H17.9905C18.5415 17 18.9905 17.449 18.9905 18V20Z" })] }));
});
const StyledSvg = styled(Svg, getSvgStyles);
const overrides = {
  Svg: {
    component: StyledSvg
  }
};
const IconPeople = forwardRef((props, ref) => jsx(Icon, __spreadValues({ ref, overrides }, props)));
IconPeople.displayName = "IconPeople";

export { IconPeople };
